import axios from 'axios';

const DEFAULT_URL = '/api/vehicle/exists.json';

export async function checkVehicleExists(value, url = DEFAULT_URL, paramName = 'uuid') {
    if (!value) {
        return false;
    }

    try {
        const response = await axios.get(url, {
            params: { [paramName]: value },
            headers: { Accept: 'application/json' },
        });

        return response?.data?.exists === true;
    } catch (error) {
        return false;
    }
}

export async function validateVehicleExistence(vehicles, url = DEFAULT_URL) {
    if (!Array.isArray(vehicles)) {
        return [];
    }

    try {
        return await Promise.all(vehicles.map(async (vehicle) => ({
            ...vehicle,
            exists: vehicle?.removed ? false : await checkVehicleExists(vehicle?.id, url),
        })));
    } catch (error) {
        return vehicles.map((vehicle) => ({ ...vehicle, exists: false }));
    }
}
